module.exports = __webpack_public_path__ + "img/beneficio-alimentacao.7165cd30.svg";